export const getIdeaList = (payload?: any) => ({
    type: "@saga/GET_IDEA_LIST",
    payload
});

